import { BottomMenuBar } from "../../components/menu/bottom-menu.component/bottom-menu.component";
import { TopMenuBar } from "../../components/menu/top-menu.component/top-menu.component";
import { UnsupportedFeatureScreen } from "../../components/unsupported-feature-screen/unsupported-feature-screen.component";
import { VersionIndicator } from "../../components/version-indicator/version-indicator.component";
import { SocialMediaFeed } from "../../feed/social_media_feed";
import { ExperimentBodyProps } from "../props";
import "./desktop-body.component.css";
import { LeftSidebar } from "./left-sidebar/left-sidebar.component";
import { RightSidebar } from "./right-sidebar/right-sidebar.component";

export function DesktopBody(props: ExperimentBodyProps) {
  return (
    <div className="experiment-body-container">
      <TopMenuBar
        notificationCount={5}
        branding={props.branding}
        controller={props.menuController}
        onlineUsers={props.onlineUsers}
      />
      <div className="feed-flex-container">
        <div className="left-sidebar-container">
          <LeftSidebar pageCount={5} shortcuts={props.shortcuts} />
        </div>
        <div className="feed-container">
          <SocialMediaFeed
            posts={props.posts}
            driver={props.driver}
            testId={props.testId}
            onLikePostClicked={
              props.unsupportedFeatureController.onUnsupportedFeatureInvoked
            }
            onDislikePostClicked={
              props.unsupportedFeatureController.onUnsupportedFeatureInvoked
            }
            onSharePostClicked={
              props.unsupportedFeatureController.onUnsupportedFeatureInvoked
            }
            onCommentsClicked={
              props.unsupportedFeatureController.onUnsupportedFeatureInvoked
            }
            user={props.user}
          />
        </div>
        <div className="right-sidebar-container">
          <RightSidebar
            sponsored={props.sponsored}
            birthdays={props.birthdays}
            showContacts={props.showContacts}
            leaderboard={props.leaderboard}
            contacts={props.contacts}
          />
        </div>
      </div>
      <VersionIndicator experimentVersion={props.version} />
      <BottomMenuBar
        notificationCount={5}
        branding={props.branding}
        controller={props.menuController}
      />
      <UnsupportedFeatureScreen
        controller={props.unsupportedFeatureController}
      />
    </div>
  );
}
